"use client";

import React from "react";
function CtaButton({
  href,
  children,
  variant = "primary"
}: {
  href: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary";
}) {
  return <>
      <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel={href.startsWith("http") ? "noreferrer" : undefined} className={`gallery-cta group relative inline-flex h-14 items-center justify-center overflow-hidden rounded-full border px-8 text-base font-semibold transition-all duration-300 hover:-translate-y-0.5 ${variant === "primary" ? "border-white/10 bg-white text-slate-900 shadow-[0_12px_32px_rgba(15,23,42,0.22)] hover:border-[#166534] hover:bg-[#166534] hover:text-white hover:shadow-[0_18px_42px_rgba(22,101,52,0.28)]" : "border-white/16 bg-white/10 text-white shadow-[0_12px_28px_rgba(15,23,42,0.14)] backdrop-blur-sm hover:border-[#166534]/60 hover:bg-[#166534] hover:text-white hover:shadow-[0_18px_40px_rgba(22,101,52,0.24)]"}`}>
        <span className="relative z-10">{children}</span>
      </a>

      <style jsx>{`
        .gallery-cta::before {
          content: "";
          position: absolute;
          top: 0;
          left: -130%;
          width: 52%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.16),
            transparent
          );
          transform: skewX(-18deg);
          transition: left 0.85s ease;
        }

        .gallery-cta:hover::before {
          left: 130%;
        }
      `}</style>
    </>;
}
export default function GalleryFinalCtaSection() {
  return <section className="bg-[#fbfbf8] px-6 pb-24 md:px-12 md:pb-28">
      <div className="mx-auto max-w-4xl">
        <div className="overflow-hidden rounded-[40px] bg-[#0f172a] px-8 py-10 text-white shadow-[0_24px_60px_rgba(0,0,0,0.18)] md:px-12 md:py-14">
          <div className="mb-5 inline-flex items-center rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-white/72 backdrop-blur-md sm:text-xs">
            Познакомиться лично
          </div>

          <h2 className="mb-5 font-default text-3xl font-bold tracking-[-0.03em] text-white sm:text-4xl md:text-5xl">
            Хотите увидеть всё <span className="text-[#166534]">своими глазами?</span>
          </h2>

          <p className="mb-8 max-w-2xl font-default text-lg leading-relaxed text-white/78 md:text-xl">
            Запишитесь на бесплатную диагностику и познакомьтесь с нашим центром лично.
          </p>

          <div className="flex flex-col gap-4 sm:flex-row">
            <CtaButton href="https://wa.me/905465166807">
              Записаться на диагностику
            </CtaButton>

            <CtaButton href="tel:+905465166807" variant="secondary">
              Связаться с нами
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}